import React from 'react'
import App from './App'

export default function DirectorsAsyncJobs({ appProps, screenClass, sidekiqPath, title, description, labels }) {
  return (
    <App appProps={ appProps }>
      <div className={ screenClass }>
        <div className='director-shell'>
          <section className='director-header'>
            <div>
              <span>{ labels.eyebrow }</span>
              <h1>{ title }</h1>
              <p>{ description }</p>
            </div>
          </section>

          <section className='director-iframe-panel'>
            <iframe
              src={ sidekiqPath }
              title={ title }
              className='director-sidekiq-frame'>
            </iframe>
          </section>
        </div>
      </div>
    </App>
  )
}
